import React, { useState, useEffect } from "react";
import exclusive_image from "../Assets/exclusive_image.png";
import { Link } from "react-router-dom";

const useCountdown = (targetSeconds) => {
  const [time, setTime] = useState(targetSeconds);
  useEffect(() => {
    const t = setInterval(() => setTime(prev => (prev > 0 ? prev - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, []);
  const h = String(Math.floor(time / 3600)).padStart(2, '0');
  const m = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
  const s = String(time % 60).padStart(2, '0');
  return { h, m, s };
};

const TimeBox = ({ value, label, accent }) => (
  <div className="flex flex-col items-center">
    <div
      className="w-[60px] h-[60px] max-[600px]:w-[48px] max-[600px]:h-[48px] rounded-xl flex items-center justify-center text-white text-2xl max-[600px]:text-xl font-black border font-mono tracking-wider shadow-lg"
      style={{ background: `${accent}22`, borderColor: `${accent}55` }}
    >
      {value}
    </div>
    <span className="text-[#6b7a8d] text-[10px] font-bold tracking-[1.5px] uppercase mt-1.5">{label}</span>
  </div>
);

const Offers = () => {
  const { h, m, s } = useCountdown(6 * 3600 + 42 * 60 + 18);
  const accent = '#00d4ff';

  return (
    <div className="py-10 px-[8%]">
      {/* Flash Sale Banner */}
      <div className="relative rounded-3xl overflow-hidden border border-white/[0.06] mb-8" style={{ background: 'linear-gradient(135deg, #0d1526 0%, #111827 50%, #0a0f1e 100%)' }}>
        {/* Top flash strip */}
        <div className="w-full py-2.5 px-8 flex items-center justify-center gap-3 text-sm font-bold text-[#060c18] tracking-wider" style={{ background: 'linear-gradient(90deg, #00d4ff, #7c3aed)' }}>
          <span className="animate-pulse text-base">⚡</span>
          FLASH SALE — ENDS SOON! LIMITED STOCK AVAILABLE
          <span className="animate-pulse text-base">⚡</span>
        </div>
        {/* Orbs */}
        <div className="absolute w-[500px] h-[500px] -top-48 -right-24 rounded-full blur-[60px] pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.12) 0%, transparent 70%)' }} />
        <div className="absolute w-[350px] h-[350px] -bottom-36 -left-12 rounded-full blur-[50px] pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.12) 0%, transparent 70%)' }} />

        <div className="relative z-10 flex items-center justify-between py-[52px] px-[8%] gap-10 max-[800px]:flex-col max-[800px]:text-center max-[800px]:py-[40px]">
          {/* Left */}
          <div className="flex-1 max-w-[520px]">
            <div className="inline-block bg-[rgba(0,212,255,0.1)] text-[#00d4ff] border border-[rgba(0,212,255,0.3)] px-4 py-[5px] rounded-full text-xs font-extrabold tracking-[2px] uppercase mb-5">⚡ LIMITED TIME OFFER</div>
            <h1 className="text-[46px] font-black text-white leading-[1.05] mb-4 -tracking-[1.5px] max-[1100px]:text-[38px] max-[800px]:text-[34px] max-[500px]:text-[28px]">
              Exclusive<br />
              <span className="bg-gradient-to-br from-[#00d4ff] to-[#7c3aed] bg-clip-text text-transparent">Tech Deals</span>
            </h1>
            <p className="text-[#8896a6] text-base leading-[1.7] mb-7 max-w-[400px] max-[800px]:mx-auto">Score massive savings on top-rated laptops, phones, and accessories. Only while stocks last.</p>
            <div className="flex gap-3 flex-wrap mb-7 max-[800px]:justify-center">
              {[
                { pct: '40%', label: 'OFF Laptops', c: '#00d4ff' },
                { pct: '25%', label: 'OFF Phones', c: '#a78bfa' },
                { pct: '30%', label: 'OFF Access.', c: '#fbbf24' },
              ].map(({ pct, label, c }) => (
                <div key={label} className="flex flex-col items-center px-[18px] py-3 rounded-xl border bg-white/[0.03] backdrop-blur-sm text-xs font-semibold min-w-[85px]" style={{ borderColor: `${c}44`, color: c }}>
                  <span className="text-2xl font-black leading-none mb-1">{pct}</span>
                  <span>{label}</span>
                </div>
              ))}
            </div>
            <Link to="/laptops">
              <button className="px-8 h-[52px] rounded-xl border-none bg-gradient-to-br from-[#00d4ff] to-[#0077aa] text-[#060c18] text-base font-extrabold cursor-pointer font-[inherit] transition-all duration-200 shadow-[0_0_24px_rgba(0,212,255,0.3)] hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(0,212,255,0.55)]">Shop All Deals →</button>
            </Link>
          </div>

          {/* Right — countdown + image */}
          <div className="relative z-10 flex flex-col items-center gap-5">
            <div className="flex flex-col items-center gap-3 bg-white/[0.04] border border-white/[0.08] rounded-2xl px-8 py-5 backdrop-blur-sm">
              <p className="text-[#8896a6] text-xs font-bold tracking-[2px] uppercase">Offer Ends In</p>
              <div className="flex items-start gap-3">
                <TimeBox value={h} label="Hours" accent={accent} />
                <span className="text-[#00d4ff] text-3xl font-black mt-2.5 -mx-1">:</span>
                <TimeBox value={m} label="Mins" accent={accent} />
                <span className="text-[#00d4ff] text-3xl font-black mt-2.5 -mx-1">:</span>
                <TimeBox value={s} label="Secs" accent={accent} />
              </div>
            </div>
            <div className="relative max-[800px]:hidden">
              <img src={exclusive_image} alt="Flash Sale" className="w-[240px] block max-[1100px]:w-[200px]" style={{ filter: 'drop-shadow(0 0 30px rgba(0,212,255,0.25))' }} />
              <div className="absolute top-0 -right-2 flex flex-col items-center justify-center w-[82px] h-[82px] rounded-full bg-gradient-to-br from-[#00d4ff] to-[#7c3aed] text-white leading-[1.2]">
                <span className="text-[10px] font-semibold">Up to</span>
                <span className="text-[22px] font-black">40%</span>
                <span className="text-[12px] font-bold">OFF</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Promo strips */}
      <div className="grid grid-cols-3 gap-5 max-[700px]:grid-cols-1">
        {[
          { icon: '🎧', title: 'Audio Deals', sub: 'Headphones from Rs. 999', link: '/accessories', c: '#00d4ff' },
          { icon: '⌚', title: 'Smart Watches', sub: 'Premium brands, huge savings', link: '/accessories', c: '#7c3aed' },
          { icon: '🖥️', title: 'Monitor Sale', sub: 'Gaming & work monitors', link: '/accessories', c: '#f59e0b' },
        ].map(({ icon, title, sub, link, c }) => (
          <Link to={link} key={title}>
            <div className="flex items-center gap-4 px-5 py-4 rounded-2xl border cursor-pointer hover:-translate-y-1 transition-all duration-300 group" style={{ background: `${c}0d`, borderColor: `${c}33` }}>
              <span className="text-4xl">{icon}</span>
              <div>
                <p className="text-white font-bold text-sm mb-0.5">{title}</p>
                <p style={{ color: c }} className="text-xs font-semibold">{sub}</p>
              </div>
              <span className="ml-auto text-white/40 group-hover:text-white/80 transition-colors text-lg">→</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Offers;
